<form [formGroup]="ratePeriodForm" (ngSubmit)="isFormSubmitted = true;updatePeriod()" (keydown.enter)="$event.preventDefault()">
    <!-- <div class="modal-dialog modal-dialog-centered detail-modal">
      <div class="modal-content">
        
      </div>
    </div> -->
    <div class="modal-header">
        <h4 class="modal-title">Update Period Info.</h4>
    <button type="button" class="btn-close" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
      <div class="card">
          <!-- <div class="card- bg-transparent border-bottom"> Additional Details</div> -->
          <div class="card-body" [formGroup]="ratePeriodForm">
              <div class="row">
                  <div class="col-md-4">
                      <div class="mb-2">
                          <label class="form-label">Rate Type<span class="mandatory">*</span></label>
                          <ng-select id="ratetype" placeholder="Select" [items]="rateTypes" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                              bindLabel="ratetype" [bindValue]="'id'" formControlName="ddlRateType"  >
                          </ng-select>
                      </div>
                  </div>
                  <div class="col-md-4" *ngIf="showRateBand">
                      <div class="mb-2">
                          <label for="RateBandRate" class="form-label">Rate Bands<span
                                  class="mandatory">*</span></label>
                          <ng-select id="RateBand" [items]="rateBandList" bindLabel="rateband"
                              placeholder="Select" [bindValue]="'id'" formControlName="ddlRateBand" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                              [ngClass]="{'is-invalid': (isFormSubmitted || ratePeriodForm.get('ddlRateBand')?.touched) && ratePeriodForm.get('ddlRateBand').errors}"  >
                          </ng-select>
                          <div *ngIf="(isFormSubmitted || ratePeriodForm.get('ddlRateBand')?.touched) && ratePeriodForm.get('ddlRateBand').errors"
                              class="invalid-feedback">
                              <span *ngIf="ratePeriodForm.get('ddlRateBand').errors.required">Rate Band is
                                  Required</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-4" *ngIf="showCustomer">
                      <div class="mb-2">
                          <label for="CustomerRate" class="form-label">Customer<span
                                  class="mandatory">*</span></label>
                          <ng-select id="CustomerRate" [items]="customerList" bindLabel="name"
                              placeholder="Select" [bindValue]="'id'" formControlName="ddlCustomer" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                              [ngClass]="{'is-invalid': (isFormSubmitted || ratePeriodForm.get('ddlCustomer')?.touched) && ratePeriodForm.get('ddlCustomer').errors}"  >
                              <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                <span>{{ item.name }}</span>
                            </ng-template>
                          </ng-select>
                          <div *ngIf="(isFormSubmitted || ratePeriodForm.get('ddlCustomer')?.touched) && ratePeriodForm.get('ddlCustomer').errors"
                              class="invalid-feedback">
                              <span *ngIf="ratePeriodForm.get('ddlCustomer').errors.required">Customer is
                                  Required</span>
                          </div>
                      </div>
                  </div>
                  <div class="col-md-4" *ngIf="showVendor">
                      <div class="mb-2">
                          <label for="Vendor" class="form-label">Vendor<span
                                  class="mandatory">*</span></label>
                          <ng-select id="Vendor" [items]="vendorList" bindLabel="name"
                              placeholder="Select" [bindValue]="'id'" formControlName="ddlVendor" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                              [ngClass]="{'is-invalid': (isFormSubmitted || ratePeriodForm.get('ddlVendor')?.touched) && ratePeriodForm.get('ddlVendor').errors}"  >
                              <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                <span>{{ item.name }}</span>
                            </ng-template>
                          </ng-select>
                          <div *ngIf="(isFormSubmitted || ratePeriodForm.get('ddlVendor')?.touched) && ratePeriodForm.get('ddlVendor').errors"
                              class="invalid-feedback">
                              <span *ngIf="ratePeriodForm.get('ddlVendor').errors.required">Vendor
                                  is Required</span>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="row">
                  <div class="col-md-4">
                      <div class="mb-2">
                          <label for="fromDate" class="form-label">From Date<span
                                  class="mandatory">*</span></label>
                          <input id="fromDate" class="form-control form-control-sm" type="date"
                              formControlName="txtFromDate"  >
                      </div>
                  </div>
                  <div class="col-md-4">
                      <div class="mb-2">
                          <label for="toDate" class="form-label">To Date<span
                                  class="mandatory">*</span></label>
                          <input id="toDate" class="form-control form-control-sm" type="date"
                              formControlName="txtToDate" [min]="currentDate"
                              [ngClass]="{'is-invalid': (isFormSubmitted || ratePeriodForm.get('txtToDate').touched) && ratePeriodForm.get('txtToDate').errors}"  >
                          <div *ngIf="(isFormSubmitted || ratePeriodForm.get('txtToDate').touched) && ratePeriodForm.get('txtToDate').errors"
                              class="invalid-feedback">
                              <span *ngIf="ratePeriodForm.get('txtToDate').errors.required">Date is
                                  Required</span>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="updatePeriod()">Update</button>
  </div>
</form>